export const LanguageEnum = {
  English: 1,
  Spanish: 2,
  French: 3,
  Latin: 4,
  Russian: 5,
  German: 6,
  Italian: 7,
  Dutch: 8,
  Vietnamese: 9,
  Korean: 10,
  Polish: 11,
  Portuguese: 12,
  Japanese: 13,
  Greek: 14,
  Hindi: 15,
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/LanguageEnum.js